<template>
  <div class="home">
    <!-- 英雄区域 - Element UI轮播图 -->
    <section class="hero-section">
      <el-carousel 
        :interval="2000" 
        trigger="click"
        indicator-position="inside"
        arrow="hover"
        class="hero-carousel"
      >
        <el-carousel-item v-for="(image, index) in carouselImages" :key="index">
          <div class="carousel-item">
            <img :src="image.src" :alt="image.alt" class="carousel-image">
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- 核心业务部分 -->
    <section class="core-business">
      <div class="container">
        <h2 class="section-title">核心业务</h2>
        <div class="business-grid">
          <div class="business-card" 
               v-for="(card, index) in businessCards" 
               :key="index"
               @mousemove="handleMouseMove"
               @mouseleave="handleMouseLeave"
               ref="cards">
            <h3 class="card-title">{{ card.title }}</h3>
            <p class="card-description" v-html="card.description"></p>
          </div>
        </div>
      </div>
    </section>

    <!-- 行业覆盖部分 -->
    <section class="industry-coverage">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">行业覆盖</h2>
        </div>
        
        <div class="industry-grid">
          <div class="industry-card" 
               v-for="(industry, index) in industryCards" 
               :key="index">
            <div class="card-image">
              <img :src="industry.image" :alt="industry.title" class="industry-image">
            </div>
            <div class="card-content">
              <div class="card-header">
                <div class="industry-icon">
                  <i :class="industry.icon"></i>
                </div>
                <h3 class="industry-title">{{ industry.title }}</h3>
              </div>
              <p class="industry-description">{{ industry.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务客户部分 -->
    <section class="service-customers">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">服务客户</h2>
          <p class="section-tagline">"一些很棒的客户,对我们的认可和评价!"</p>
        </div>
        
        <div class="testimonial-grid">
          <div class="testimonial-card" 
               v-for="(testimonial, index) in testimonialCards" 
               :key="index"
               :class="{ 'active': testimonial.active }">
            <div class="company-info">
              <h3 class="company-name">{{ testimonial.company }}</h3>
              <div class="time-info">
                <i class="el-icon-time"></i>
                <span>{{ testimonial.time }}</span>
              </div>
            </div>
            <div class="testimonial-content">
              <p class="testimonial-text">"{{ testimonial.text }}"</p>
            </div>
            <div class="star-rating">
              <i v-for="n in 5" :key="n" 
                 :class="n <= testimonial.rating ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      carouselImages: [
        {
          src: require('@/assets/slide4.jpg'),
          alt: '轮播图4'
        },
        {
          src: require('@/assets/slide1.jpg'),
          alt: '轮播图1'
        },
        {
          src: require('@/assets/slide2.jpg'),
          alt: '轮播图2'
        },
        {
          src: require('@/assets/slide3.jpg'),
          alt: '轮播图3'
        }
      ],
      businessCards: [
        {
          title: '软件开发',
          description: '提供专业的软件开发服务<br>满足企业多样化需求'
        },
        {
          title: '人工智能应用',
          description: '人工智能技术研发与应用<br>助力企业数字化转型'
        },
        {
          title: '物联网技术',
          description: '物联网解决方案<br>打造智能化生态系统'
        },
        {
          title: '大数据服务',
          description: '数据挖掘与分析<br>为企业决策提供支持'
        }
      ],
      industryCards: [
        {
          title: '互联网行业',
          description: '基于SaaS应用开发架构和大数据、AI及物联网技术,并结合其在移动应用开发领域积累的多年经验和技术,持续聚焦服务...',
          icon: 'el-icon-eleme',
          image: require('@/assets/web.jpg')
        },
        {
          title: '制造行业',
          description: '结合物联网、互联网、云计算、大数据等相关信息技术,赋能制造业企业智能化、数字化转型...',
          icon: 'el-icon-s-grid',
          image: require('@/assets/web2.jpg')
        },
        {
          title: '电信行业',
          description: '通过信息技术和服务的高效组合,持续助力电信企业保持技术的专业性,为企业带来获得更低的成本、更优的质量和更高的效率...',
          icon: 'el-icon-cpu',
          image: require('@/assets/web3.jpg')
        }
      ],
      testimonialCards: [
        {
          company: 'ZLW',
          time: '6个月前',
          text: '一直是我们优秀的合作伙伴,为我们提供高质量的交付团队和优秀的IT技术人才。',
          rating: 5,
          active: true
        },
        {
          company: 'ZSY',
          time: '3个月前',
          text: '有稳定可靠的开发团队,能提供我们所需的高标准应用软件开发资源和服务,他们真的很认真,非常谦逊的家伙!!!',
          rating: 5,
          active: true
        },
        {
          company: 'ZHN',
          time: '2个月前',
          text: '有积极主动的技术团队,交付效率很出色,帮助我们更高效地完成工作。',
          rating: 5,
          active: true
        }
      ]
    }
  },
  methods: {
    handleMouseMove(event) {
      const card = event.currentTarget;
      const rect = card.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const rotateX = (y - centerY) / 10;
      const rotateY = (centerX - x) / 10;
      
      card.style.transform = `perspective(500px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(10px)`;
    },
    handleMouseLeave(event) {
      const card = event.currentTarget;
      card.style.transform = 'perspective(500px) rotateX(0deg) rotateY(0deg) translateZ(0px)';
    }
  }
}
</script>

<style scoped lang="scss">
// 英雄区域样式
.hero-section {
  position: relative;
  overflow: hidden;
}

.carousel-item {
  width: 100%;
  height: 500px;
  position: relative;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

// 轮播图样式调整
.hero-carousel {
  ::v-deep .el-carousel__arrow {
    background-color: rgba(0, 0, 0, 0.7);
  }
  
  ::v-deep .el-carousel__indicator {
    .el-carousel__button {
      border-radius: 50% !important;
      width: 12px !important;
      height: 12px !important;
    }
  }

  ::v-deep .el-carousel__container {
    height: 500px;
  }
}

// 核心业务部分样式
.core-business {
  padding: 80px 0;
  background: #f8fafc;
}

.container {
  max-width: 75rem; /* 1200px / 16px = 75rem */
  margin: 0 auto;
  padding: 0 1.25rem; /* 20px / 16px = 1.25rem */
}

.section-title {
  text-align: center;
  font-size: 2.3rem;
  color: black;
  margin-bottom: 3.75rem; /* 60px / 16px = 3.75rem */
  font-weight: bold;
}

.business-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.875rem; /* 30px / 16px = 1.875rem */
}

.business-card {
  background: white;
  padding: 2.5rem 1.875rem; /* 40px 30px / 16px = 2.5rem 1.875rem */
  border-radius: 0.625rem; /* 10px / 16px = 0.625rem */
  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  
  &:hover {
    box-shadow: 0 0.5rem 1.5625rem rgba(0, 0, 0, 0.15);
  }
}

.card-icon {
  font-size: 3rem;
  margin-bottom: 20px;
}

.card-title {
  font-size: 1.5rem;
  color: black;
  margin-bottom: 15px;
  font-weight: bold;
}

.card-description {
  color: #6b7280;
  line-height: 1.6;
}

// 行业覆盖部分样式
.industry-coverage {
  padding: 80px 0;
  background: #f8fafc;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.header-icon {
  font-size: 4rem;
  color: #4f46e5;
  margin-bottom: 20px;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #6b7280;
  margin-bottom: 10px;
}

.section-tagline {
  font-size: 1.1rem;
  color: #6b7280;
  line-height: 1.8;
}

.industry-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.industry-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease;
  
  &:hover {
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
}

.card-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.industry-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.card-content {
  padding: 25px 30px;
  flex-grow: 1;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.industry-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  
  i {
    font-size: 1.5rem;
    color: #344767;
  }
}

.industry-title {
  font-size: 1.3rem;
  color: black;
  font-weight: bold;
}

.industry-description {
  color: #6b7280;
  line-height: 1.6;
}

// 服务客户部分样式
.service-customers {
  padding: 80px 0;
  background: #f8fafc;
}

.testimonial-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  justify-content: center;
}

.testimonial-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
  transition: all 0.2s ease;
  cursor: pointer;

  &.active {
    background: #4f46e5;
    color: white;
    
    .company-name,
    .testimonial-text {
      color: white;
    }
    
    .time-info {
      color: rgba(255, 255, 255, 0.8);
    }
    
    .star-rating i {
      color: #f5c518;
    }
  }

  &:hover {
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
}

.company-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.company-name {
  font-size: 1.2rem;
  font-weight: bold;
  color: black;
}

.time-info {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #6b7280;

  i {
    margin-right: 5px;
    font-size: 0.9rem;
  }
}

.testimonial-content {
  font-size: 1rem;
  color: #6b7280;
  line-height: 1.8;
  margin-bottom: 15px;
}

.testimonial-text {
  font-style: italic;
  color: #333;
}

.star-rating {
  display: flex;
  gap: 5px;

  i {
    font-size: 1.2rem;
    color: #f5c518; /* Gold color for stars */
  }
}

// 手机端轮播图优化
@media (max-width: 768px) {
  .carousel-item {
    height: 400px;
    margin: 10px 0;
  }
  
  .carousel-image {
    object-fit: contain;
    object-position: center top;
  }
  
  .hero-section {
    width: 100%;
    overflow: hidden;
  }
  
  // 减少核心业务部分的间距
  .core-business {
    padding: 40px 0;
  }
  
  .section-title {
    margin-bottom: 2rem;
    font-size: 1.8rem; /* 平板端标题进一步缩小 */
  }
  
  // 平板端改为2列布局
  .business-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 1.5rem;
  }
  
  .business-card {
    padding: 1.8rem 1.2rem; /* 减少内边距 */
  }
  
  .card-title {
    font-size: 1.1rem; /* 标题进一步缩小 */
    margin-bottom: 0.8rem;
  }
  
  .card-description {
    font-size: 0.85rem; /* 描述文字也缩小 */
    line-height: 1.4;
  }
  
  // 行业覆盖部分平板端优化
  .industry-coverage {
    padding: 40px 0;
  }
  
  .industry-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 1.5rem;
  }
  
  .industry-card {
    padding: 1.8rem 1.2rem;
  }
  
  .card-image {
    height: 150px; /* 平板端图片高度减少 */
  }
  
  .card-content {
    padding: 1.5rem 1.2rem; /* 减少内容区域内边距 */
  }
  
  .industry-title {
    font-size: 1.1rem;
    margin-bottom: 0.8rem;
  }
  
  .industry-description {
    font-size: 0.85rem;
    line-height: 1.4;
  }
  
  .industry-icon {
    width: 18px;
    height: 18px;
    
    i {
      font-size: 1.3rem;
    }
  }
  
  // 服务客户部分平板端优化
  .service-customers {
    padding: 40px 0;
  }
  
  .testimonial-grid {
    grid-template-columns: 1fr !important; /* 平板端改为1列 */
    gap: 1.5rem;
  }
  
  .testimonial-card {
    padding: 1.8rem 1.2rem;
  }
  
  .company-name {
    font-size: 1.1rem;
  }
  
  .testimonial-text {
    font-size: 0.85rem;
    line-height: 1.4;
  }
  
  .time-info {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .carousel-item {
    height: 400px;
    margin: 0;
  }
  
  .carousel-image {
    object-fit: contain;
    object-position: center top;
  }
  
  // 去掉手机端的所有间距
  .core-business {
    padding: 0;
  }
  
  .section-title {
    margin-bottom: 1rem;
    font-size: 1.6rem; /* 手机端标题更小 */
  }
  
  // 手机端改为2列布局，进一步缩小
  .business-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 0.8rem; /* 进一步减少卡片间距 */
  }
  
  .business-card {
    padding: 1.2rem 0.8rem; /* 进一步减少内边距 */
  }
  
  .card-title {
    font-size: 1rem; /* 手机端标题更小 */
    margin-bottom: 0.6rem;
  }
  
  .card-description {
    font-size: 0.8rem; /* 描述文字更小 */
    line-height: 1.3;
  }
  
  // 行业覆盖部分手机端优化
  .industry-coverage {
    padding: 0;
  }
  
  .industry-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 0.8rem;
  }
  
  .industry-card {
    padding: 1.2rem 0.8rem;
  }
  
  .card-image {
    height: 120px; /* 手机端图片高度进一步减少 */
  }
  
  .card-content {
    padding: 1rem 0.8rem; /* 手机端内容区域内边距更小 */
  }
  
  .industry-title {
    font-size: 1rem;
    margin-bottom: 0.6rem;
  }
  
  .industry-description {
    font-size: 0.8rem;
    line-height: 1.3;
  }
  
  .industry-icon {
    width: 16px;
    height: 16px;
    
    i {
      font-size: 1.1rem;
    }
  }
  
  // 服务客户部分手机端优化
  .service-customers {
    padding: 0;
  }
  
  .testimonial-grid {
    grid-template-columns: 1fr !important; /* 手机端改为1列 */
    gap: 0.8rem;
  }
  
  .testimonial-card {
    padding: 1.2rem 0.8rem;
  }
  
  .company-name {
    font-size: 1rem;
  }
  
  .testimonial-text {
    font-size: 0.8rem;
    line-height: 1.3;
  }
  
  .time-info {
    font-size: 0.75rem;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }
  
  .business-grid {
    grid-template-columns: 1fr;
  }

  .industry-grid {
    grid-template-columns: 1fr;
  }

  .testimonial-grid {
    grid-template-columns: 1fr;
  }

  .testimonial-card {
    min-width: auto;
  }
}

// 手机端适配
@media (max-width: 768px) {
  .carousel-item {
    height: 400px;
  }
  
  .hero-carousel {
    ::v-deep .el-carousel__container {
      height: 230px;
    }
    
    ::v-deep .el-carousel__arrow {
      width: 35px;
      height: 35px;
      font-size: 16px;
    }
    
    ::v-deep .el-carousel__indicator {
      .el-carousel__button {
        width: 10px !important;
        height: 10px !important;
      }
    }
  }
  
  .core-business {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 2rem;
    margin-bottom: 40px;
  }
  
  .business-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .business-card {
    padding: 30px 20px;
  }
  
  .industry-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .industry-coverage {
    padding: 60px 0;
  }
  
  .service-customers {
    padding: 60px 0;
  }
}

@media (max-width: 480px) {
  .carousel-item {
    height: 400px;
  }
  
  .hero-carousel {
    ::v-deep .el-carousel__container {
      height: 230px;
    }
    
    ::v-deep .el-carousel__arrow {
      width: 30px;
      height: 30px;
      font-size: 14px;
    }
    
    ::v-deep .el-carousel__indicator {
      .el-carousel__button {
        width: 8px !important;
        height: 8px !important;
      }
    }
  }
  
  .core-business {
    padding: 40px 0;
  }
  
  .section-title {
    font-size: 1.8rem;
    margin-bottom: 30px;
  }
  
  .business-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .business-card {
    padding: 25px 15px;
  }
  
  .card-title {
    font-size: 1.3rem;
  }
  
  .industry-grid {
    gap: 15px;
  }
  
  .industry-coverage {
    padding: 40px 0;
  }
  
  .service-customers {
    padding: 40px 0;
  }
  
  .container {
    padding: 0 15px;
  }
}
</style>
